import { AnyAction } from "redux";
import { Dispatch } from "react";
import { Create } from "../../../actorTyes";
import { Adapter } from "../../../../shared/adapter";
import { ActorTypeRaw, Result } from "../../../../interfaces";
import { CapacitiesTypesAdapter } from "../../../../adapter/capacitiesTypes-adapter";

export const FETCH_CREATE_CAPACITIES_TYPES_REQUEST = 'FETCH_CREATE_CAPACITIES_TYPES_REQUEST';
export const FETCH_CREATE_CAPACITIES_TYPES_SUCCESS = 'FETCH_CREATE_CAPACITIES_TYPES_SUCCESS';
export const FETCH_CREATE_CAPACITIES_TYPES_FAILURE = 'FETCH_CREATE_CAPACITIES_TYPES_FAILURE';

interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchCreateCapacitiesTypeRequest = () => {
    return {
        type: FETCH_CREATE_CAPACITIES_TYPES_REQUEST,
    };
};

const fetchCreateCapacitiesTypeSuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_CREATE_CAPACITIES_TYPES_SUCCESS,
        payload: data
    };
};

const fetchCreateCapacitiesTypeFailure = (error: any) => {
    return {
        type: FETCH_CREATE_CAPACITIES_TYPES_FAILURE,
        payload: error,
    };
};

export const clear = ()=>{
    return {
        type: "CLEAR_DATA",
    };  
}

export const create = (actorType:ActorTypeRaw) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchCreateCapacitiesTypeRequest());
        try {
            const response = await Create(actorType);
            dispatch(fetchCreateCapacitiesTypeSuccess(
                Adapter.from(response.data).to((value) => new CapacitiesTypesAdapter(value).adapt())
            ));
        } catch (error: any) {
            dispatch(fetchCreateCapacitiesTypeFailure(error.message));
        }
    };
};
